import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular-ivy';
import { BrowserTracing } from '@sentry/tracing';
import { ExtraErrorData } from '@sentry/integrations';

import { AppModule } from '@app/app.module';
import { environment } from '@environments/environment';
import packageJson from 'package.json';

// #region -> Sentry <-
// ----------

Sentry.init({
  dsn: environment.sentry.dsn,
  environment: environment.envName,
  // Enable the following line is need to enable `debug` in the `dev` env.
  // debug: environment.production ? false : true,
  debug: false,
  // The `depth` should cover a GraphQL error.
  normalizeDepth: 6,
  release:
    environment.envName === 'prod'
      ? `${packageJson.version}-${packageJson.buildNumber}`
      : `${packageJson.version}-${packageJson.buildNumber} | ${environment.envName}`,
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: environment.sentry.tracePropagationTargets,
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    new ExtraErrorData({ depth: 7 }), //  `normalizeDepth` + 1
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: environment.sentry.tracesSampleRate,
});

// ----------
// #endregion

// ///////////////////////////

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
